/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import InputContainer from './InputContainer';
import { useEffect } from 'react';

const TextInputWithDropdown = ({
    textValue,
    setTextValue,
    dropdownValue,
    setDropdownValue,
    dropdownClassName,
    autoFocus,
    className,
    placeholder,
    options,
    label,
    id,
}) => {
    return (
        <InputContainer label={label} id={id} className={className}>
            {/*<label htmlFor="price" className="block text-sm font-medium leading-6 text-gray-900">*/}
            {/*    Price*/}
            {/*</label>*/}
            <div className="relative rounded-lg">
                {/*<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">*/}
                {/*    <span className="text-gray-500 sm:text-sm">$</span>*/}
                {/*</div>*/}
                <input
                    type="text"
                    value={textValue}
                    onChange={e => setTextValue(e.target.value)}
                    className="w-full"
                    autoFocus={autoFocus}
                    placeholder={placeholder}
                />
                <div className="absolute inset-y-0 right-0 flex items-center">
                    {/*<label htmlFor="currency" className="sr-only">*/}
                    {/*    Currency*/}
                    {/*</label>*/}
                    <select
                        className={`
                            h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm
                            ${dropdownClassName}
                        `}
                        value={dropdownValue}
                        onChange={e => setDropdownValue(e.target.value)}
                    >
                        {options.map(opt => (
                            <option value={opt.value} key={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </InputContainer>
    );
};

export default TextInputWithDropdown;
